import type { PostCommentsData } from '@/types';
import { CommentButton } from '@/ui/CommentButton';
import { TooltipWrapper } from '@/ui/TooltipWrapper';

import * as styles from '../PostActions.css';

interface CommentActionWithTooltipProps {
  translations?: Record<string, string>;
  data: PostCommentsData;
  onClick?: () => void;
}

export const CommentActionButton = ({ onClick, translations, ...props }: CommentActionWithTooltipProps) => {
  const label = translations?.['search.pagination.comment'];
  // The count is the button's only visible text, including 0. aria-label replaces that text,
  // so the name has to keep the count or the visible number drops out of the accessible name.
  const visibleCount = typeof props.data?.commentsCount !== 'undefined' ? String(props.data.commentsCount) : '';
  const ariaLabel = label ? (visibleCount ? `${label} ${visibleCount}` : label) : undefined;

  if (label) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={label}>
        <CommentButton onClick={onClick} styles={styles} data={props.data} aria-label={ariaLabel} />
      </TooltipWrapper>
    );
  }

  return <CommentButton onClick={onClick} data={props.data} styles={styles} />;
};
